import { OrgGuideFileVersion } from "../../../../generated/graphqlTypes";
import { WorkbenchDiffStatus } from "../../../workbench/state/diffStatus";

type MinimalOrgGuideFileVersion = Pick<
  OrgGuideFileVersion,
  "id" | "contentsText"
>;
export function calculateOrgGuideFileDiffStatus({
  baseVersion,
  headVersion,
}: {
  baseVersion: MinimalOrgGuideFileVersion | null;
  headVersion: MinimalOrgGuideFileVersion | null;
}): WorkbenchDiffStatus {
  if (baseVersion == null && headVersion == null) {
    return WorkbenchDiffStatus.UNMODIFIED;
  } else if (baseVersion == null) {
    return WorkbenchDiffStatus.ADDED;
  } else if (headVersion == null) {
    return WorkbenchDiffStatus.DELETED;
  } else {
    return baseVersion.contentsText === headVersion.contentsText
      ? WorkbenchDiffStatus.UNMODIFIED
      : WorkbenchDiffStatus.MODIFIED;
  }
}
